/* eslint-disable jsx-a11y/click-events-have-key-events */
import cn from 'classnames';
import { useState } from 'react';

//icons
import ChevronDown from 'ui/components/newIcons/ChevronDown';
import ChevronUp from 'ui/components/newIcons/ChevronUp';

//utils
import { trackDetailedSpecClicked } from 'src/modules/newCars/utils/events/variant';

//types
import { Typography } from 'ui';
import { Color, TypeScales } from 'ui/primitives';

//styles
import Image from 'next/legacy/image';
import { DetailedSpecificationType } from 'src/modules/newCars/types';
import s from './DetailedSpecifications.module.scss';

export const DetailedSpecifications = ({
  detail,
  label,
}: {
  detail: Array<DetailedSpecificationType>;
  label?: string;
}) => {

  const [active, setActive] = useState<string>(null);
  const [showAccordion, setShowAccordion] = useState(false);

  function handleSpecClick(itemName) {
    trackDetailedSpecClicked(itemName);
    if (active === itemName) {
      setActive(null);
    } else setActive(itemName);
  }
  return ( 
    <section className={s.root}>
      <div
        className={s.top}
        onClick={() => setShowAccordion((state) => !state)}
      >
        <Typography label={label} variant={TypeScales.body_big_m} renderAs='H2'/>
        <div className={s.chevron}>{!showAccordion ? <ChevronDown /> : <ChevronUp />}</div>
      </div>
        <div className={cn(s.bottom, {[s.hide]: !showAccordion})}>
          <div className={s.accordion}>
            {detail?.map((item) => (
              <div key={item?.title}>
                {item?.data && (
                  <div className={s.item} key={item?.title}>
                    <div
                      className={s.item_top}
                      onClick={() => handleSpecClick(item?.title)}
                    >
                      <Image alt="icons" width={20} height={20} src={item?.image} />
                      <Typography
                        label={item?.title}
                        variant={TypeScales.h5}
                        className={s.feature_label}
                      />
                      <span
                        className={cn(s.down_svg, {
                          [s.active]: item?.title === active,
                        })}
                      >
                        <ChevronDown />
                      </span>
                    </div>
                      <div className={cn(s.item_bottom, {[s.hide]: active!==item?.title})}>
                        {item?.data &&
                          (item?.data).map((detail) => (
                            <div className={s.detail} key={detail?.attr_id}>
                              <Typography
                                label={detail?.key}
                                className={s.head}
                                color={Color.text_caption}
                                variant={TypeScales.body_m}
                              />
                              <Typography
                                label={detail?.value}
                                className={s.sub_head}
                                variant={TypeScales.body_m}
                              />
                            </div>
                          ))}
                      </div>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
    </section>
  );
};
